import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/excursionDescriptionTypes', request)
}

export {get}
